import { Component } from "react";
import { connect } from "react-redux";
import { set_error_boundary } from "../../App/actions/errorBoundaryActions";
// import ErrorUIBoundary from "./ErrorUIBoundary";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Kirim error ke Redux store
    this.props.set_error_boundary({ message: error });

    console.error("Error Boundary caught an error: ", error.message);
  }


  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error && Object.keys(this.props.error).length === 0) {
      this.setState({ hasError: false });
    }
  }
  render() {
    if(this.state.hasError){
      return this.props.fallback
    }
    
    return this.props.children
  }
}

const mapStateToProps = (state) => ({
  error: state.error_boundary,
});

const mapDispatchToProps = {
  set_error_boundary: set_error_boundary,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
